import * as React from "react";
import { forwardRef } from "react";
const SvgPreCharge = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M19 9H9C7.89543 9 7 9.89543 7 11V14.3846V17C7 18.1046 7.89543 19 9 19H17H19C20.1046 19 21 18.1046 21 17V11C21 9.89543 20.1046 9 19 9Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 15.5L4.39222 16.0216C3.15464 16.2691 2 15.3225 2 14.0604V11.3846V7.15303C2 6.54448 2.54129 6.07995 3.14742 6.13412C8.82204 6.64135 10.2061 4.31879 15.1577 4.88144C15.6434 4.93663 16 5.35829 16 5.84713V9.00001",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5 7V7C5 8.10457 4.10457 9 3 9H2",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5 15V15C5 13.8954 4.10457 13 3 13H2",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 5V6C13 7.10457 13.8954 8 15 8H16",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M14 16C15.1046 16 16 15.1046 16 14C16 12.8954 15.1046 12 14 12C12.8954 12 12 12.8954 12 14C12 15.1046 12.8954 16 14 16Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgPreCharge);
export default ForwardRef;
